// CLASSES
import AppConfig from "@classes/AppConfig";

// HELPERS
import api from "@helpers/api";

export default class Partner {
  _data = null;

  constructor(name) {
    this._name = name;
  }

  // Properties
  get name() {
    return this._name;
  }

  get logoUrl() {
    return _createImageUrlForDataKey.call(this, "logo");
  }

  get isLogoClickable() {
    return _getData.call(this, "logoClickable") === true;
  }

  get backgroundUrl() {
    return _createImageUrlForDataKey.call(this, "background");
  }

  get faviconUrl() {
    return _createImageUrlForDataKey.call(this, "favicon");
  }

  get documentProcessor() {
    return _getData.call(this, "documentProcessor");
  }

  get bankid() {
    return _getData.call(this, "bankid");
  }

  get includeMeetingDocumentation() {
    return _getData.call(this, "includeMeetingDocumentation");
  }

  get requireDownloadableDocumentation() {
    let res = _getData.call(this, "requireDownloadableDocumentation");
    return res == null ? false : res;
  }

  get companyName() {
    return _getData.call(this, "companyName");
  }

  get partnerCustomerName() {
    return _getData.call(this, "partnerCustomerName");
  }

  get language() {
    return _getData.call(this, "language");
  }

  get partnerCustomerNo() {
    return _getData.call(this, "partnerCustomerNo");
  }

  get title() {
    return _getData.call(this, "title");
  }

  get accentColors() {
    return _getData.call(this, "accentColors") || {};
  }

  get borderStyle() {
    return _getData.call(this, "borderStyle") || {};
  }

  get containerShadow() {
    return _getData.call(this, "containerShadow") === true;
  }

  get allowPersonTypeChoice() {
    return _getData.call(this, "allowPersonTypeChoice") === true;
  }

  get allowCompany() {
    return _getData.call(this, "allowCompany") === true;
  }

  get allowShortSsn() {
    return _getData.call(this, "allowShortSsn") === true;
  }

  get signOnScreenEnabled() {
    return _getData.call(this, "signOnScreenEnabled") === true;
  }

  get signOnNewTab() {
    return _getData.call(this, "signOnNewTab") === true;
  }

  get skipSelectionOfSingleSignatory() {
    return _getData.call(this, "skipSelectionOfSingleSignatory") === true;
  }

  get skipSignConfirmationPage() {
    return _getData.call(this, "skipSignConfirmationPage") === true;
  }

  get sections() {
    return _getData.call(this, "sections");
  }

  get swish() {
    return _getData.call(this, "swish");
  }

  get iframed() {
    return _getData.call(this, "iframed");
  }

  get faSSO() {
    return _getData.call(this, "faSSO");
  }

  get startView() {
    return _getData.call(this, "startView");
  }

  get welcomeTitle() {
    return _getData.call(this, "welcome-title");
  }

  get welcomeSubtitle() {
    return _getData.call(this, "welcome-subtitle");
  }

  get welcomeParagraph() {
    return _getData.call(this, "welcome-paragraph");
  }

  get welcomeDisclaimer() {
    return _getData.call(this, "welcome-disclaimer");
  }

  /**
   * The app and redirect urls determines where the user is sent after the form has been completed. If the redirect url
   * is empty we will simply reset the form and start over.
   */
  get redirectUrl() {
    return _getData.call(this, "redirectUrl");
  }

  get appUrl() {
    return _getData.call(this, "appUrl");
  }

  get formCta() {
    return _getData.call(this, "form-cta");
  }

  get formCtaButton() {
    return _getData.call(this, "form-cta-button");
  }

  get formHeaderText() {
    return _getData.call(this, "form-header-text");
  }

  get formLongHeader() {
    return _getData.call(this, "form-long-header");
  }

  get formLongText() {
    return _getData.call(this, "form-long-text");
  }

  get formSubmitExplanation1() {
    return _getData.call(this, "form-submit-explanation-1");
  }

  get formSubmitExplanation2() {
    return _getData.call(this, "form-submit-explanation-2");
  }

  // Methods
  async loadData(authToken) {
    this._data = await api("partner/data", {authToken});
  }

  setupDocument() {
    // Set body className
    document.body.classList.add(this.name);

    // Set page title
    if (this.title) {
      document.title = this.title;
    }

    // Set favicon
    if (_getData.call(this, "favicon")) {
      const faviconUrl = this.faviconUrl;
      let faviconElement = document.head.querySelector("#app-favicon");

      if (faviconElement) {
        faviconElement.href = faviconUrl;
      } else {
        faviconElement = document.createElement("link");
        faviconElement.id = "app-favicon";
        faviconElement.rel = "shortcut icon";
        faviconElement.href = faviconUrl;
        document.head.appendChild(faviconElement);
      }
    }

    // fade in background image
    const bgImg = document.getElementById("app-bg");
    if (bgImg) {
      setTimeout(function () {
        document.getElementById("app-bg").classList.add("visible");
      }, 750);
    }
  }

  setData(key, value) {
    if (!this._data) {
      return;
    }

    this._data[key] = value;
  }
}

// PRIVATE FUNCTIONS
function _getData(key) {
  return (this._data && this._data[key]) || null;
}

function _createImageUrlForDataKey(dataKey) {
  if (_getData.call(this, dataKey).startsWith("#")) {
    return _getData.call(this, dataKey);
  }

  let apiUrl = AppConfig.get("apiUrl");
  if (apiUrl === "/") {
    apiUrl = window.location.protocol + "//" + window.location.hostname;
  }

  if (process.env.NODE_ENV === "development") {
    const apiServerPort = AppConfig.get("developmentOptions").apiServerPort;
    apiUrl = apiServerPort ? apiUrl + ":" + apiServerPort : apiUrl;
  }

  return apiUrl + "/partner/img?filename=" + _getData.call(this, dataKey);
}



// WEBPACK FOOTER //
// ./src/classes/Partner.js